import React, { ReactNode } from "react";
import { Box, Container, Heading, useColorMode } from "@chakra-ui/react";
import Menu from "./Menu";

interface PageLayoutProps {
  title: string;
  children: ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ title, children }) => {
  const { colorMode } = useColorMode();

  return (
    <>
      <Menu />
      <Box pt={4} pb={8}>
        <Container maxW="container.md">
          <Box p={6}>
            <Heading
              as="h1"
              size="xl"
              mb={6}
              color={colorMode === "light" ? "gray.800" : "white"}
            >
              {title}
            </Heading>
            {children}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default PageLayout;
